import { Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";

export default function Support() {
  return (
    <main data-testid="support-page" className="bg-[#FBF9F5]">
      <SEO
        title="Support | YES & AMEN"
        description="Get in touch with the YES & AMEN team. We’re here to help."
      />
      <section className="mx-auto max-w-3xl px-6 pb-36 pt-40 sm:pt-48">
        <Reveal>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#16233B]/50">
            Support
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="mt-8 font-serif text-4xl font-normal tracking-tight text-[#16233B] sm:text-5xl">
            We’re here to help.
          </h1>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-7 max-w-lg text-base leading-relaxed text-[#16233B]/60">
            Questions, feedback, or simply a hello — we’d love to hear from you. Reach out anytime
            and we’ll get back to you.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <a
            href="mailto:support@yesamen.app"
            data-testid="support-email-link"
            className="mt-11 inline-flex items-center gap-4 rounded-full border border-[#16233B]/15 bg-white px-7 py-4 shadow-[0_14px_34px_-18px_rgba(11,19,32,0.35)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-0.5 hover:border-[#16233B]/30 hover:shadow-[0_20px_44px_-18px_rgba(11,19,32,0.4)]"
          >
            <Mail className="h-5 w-5 text-[#16233B]" strokeWidth={1.5} />
            <span className="text-sm font-medium tracking-wide text-[#16233B]">
              support@yesamen.app
            </span>
          </a>
        </Reveal>
      </section>
    </main>
  );
}
